import { useLazyQuery } from '@apollo/react-hooks';
import {
  CampaignsWithInsightsQuery,
  CampaignsWithInsightsQueryVariables
} from './__generated__/CampaignsWithInsightsQuery';
import { kmsClient } from 'api';
import { CAMPAIGNS_WITH_INSIGHTS_QUERY } from './campaignsWithInsights.query';

export const useCampaignsWithInsightsLazyQuery = () => {
  return useLazyQuery<CampaignsWithInsightsQuery, CampaignsWithInsightsQueryVariables>(CAMPAIGNS_WITH_INSIGHTS_QUERY, {
    client: kmsClient,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};
